<template>
  <div class="bibliotheque-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-black uppercase">
        BIBLIOTHEQUE
      </h2>

      <!-- Contenu principal -->
      <div class="content-text max-w-4xl mx-auto text-gray-800 leading-relaxed">
        <p class="mb-4">
          L’EITP dispose d’un fonds documentaire accessible aux étudiants inscrits. 
          Dans ce cadre, divers services sont offerts aux usagers : accueil, recherche, lecture sur place.
        </p>

        <div class="mt-6">
          <h5 class="fw-semibold text-primary mb-2">Horaires de service d’accueil :</h5>
          <ul class="list-disc ps-4">
            <li>Mardi : 15h à 19h</li>
            <li>Vendredi : 12h à 15h</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BiblioTheque",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.bibliotheque-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text p {
  margin-bottom: 1rem;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}

h5 {
  color: #2b3a67;
  font-weight: 600;
}
</style>
